import { Action, createReducer, on } from '@ngrx/store'
import { YoutubeGraphPoint } from '../models/youtube-graph.model'
import { refreshData } from '../actions/criteria.actions'
import {
  loadYoutubeGraphsSuccess,
  loadYoutubeGraphsFailure,
} from '../actions/youtube-graph.actions'

export interface State {
  youtube: YoutubeGraphPoint[]
  loading: boolean
  loaded: boolean
}

export const initialState: State = { youtube: [], loading: false, loaded: false }

const youtubeGraphReducer = createReducer(
  initialState,
  on(refreshData, (state, action) => ({ ...state, loading: true, loaded: false })),
  on(loadYoutubeGraphsSuccess, (state, action) => ({
    youtube: action.youtube,
    loading: false,
    loaded: true,
  })),
  on(loadYoutubeGraphsFailure, (state, action) => state)
)

export function reducer(state: State | undefined, action: Action) {
  return youtubeGraphReducer(state, action)
}
